import React, { useEffect, useState } from 'react';
import {
  Button, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem,
  Select, Stack, Typography,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import AppDialog from '../../../shared/components/AppDialog';
import LabeledField from '../../../shared/components/LabeledField';
import { ACTION_PLAN_STATUS_LABELS } from './actionPlanModel';

/** Select one legal delivery status shared by all selected action plans. */
export default function BulkActionStatusDialog({
  actions = [], onClose, onConfirm, open, statusOptions = [], t,
}) {
  const [nextStatus, setNextStatus] = useState('');

  useEffect(() => {
    if (!open) return;
    setNextStatus('');
  }, [open, actions]);

  const canConfirm = Boolean(nextStatus && statusOptions.includes(nextStatus));

  return (
    <AppDialog fullWidth maxWidth={'xs'} onClose={onClose} open={open}>
      <DialogTitle sx={{ fontSize: 20, fontWeight: 850, pr: 7 }}>
        {t('climateAction.bulk.statusDialogTitle')}
        <IconButton
          aria-label={t('common.close')} onClick={onClose} size={'small'}
          sx={{ position: 'absolute', right: 14, top: 14 }}
        >
          <CloseRoundedIcon fontSize={'small'} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ px: 3, py: 2.5 }}>
        <Stack spacing={2.25}>
          <LabeledField
            htmlFor={'bulk-delivery-status'} label={t('climateAction.bulk.statusLabel')} required
          >
            <Select
              displayEmpty
              id={'bulk-delivery-status'}
              inputProps={{ 'aria-label': t('climateAction.bulk.statusLabel') }}
              onChange={event => setNextStatus(event.target.value)}
              renderValue={value => (
                <Typography color={value ? 'text.primary' : 'text.secondary'} component={'span'}>
                  {value
                    ? ACTION_PLAN_STATUS_LABELS[value] || value
                    : t('climateAction.bulk.selectStatus')}
                </Typography>
              )}
              size={'small'}
              value={nextStatus}
            >
              <MenuItem disabled value={''}>{t('climateAction.bulk.selectStatus')}</MenuItem>
              {statusOptions.map(status => (
                <MenuItem key={status} value={status}>
                  {ACTION_PLAN_STATUS_LABELS[status] || status}
                </MenuItem>
              ))}
            </Select>
          </LabeledField>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 1.75 }}>
        <Button color={'inherit'} onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          disabled={!canConfirm}
          onClick={() => onConfirm(nextStatus)}
          variant={'contained'}
        >
          {t('common.update')}
        </Button>
      </DialogActions>
    </AppDialog>
  );
}